// @flow

export const ProductStatus: { Published: string, InConsultation: string, InDevelopment: string, AwaitingDevelopment: string, TopicSelection: string, Prioritisation: string , Deferred: string, Terminated: string }
	= {
		Published: "Published",
		InConsultation: "InConsultation",
		InDevelopment: "InDevelopment",
		AwaitingDevelopment: "AwaitingDevelopment",
		TopicSelection: "TopicSelection",
		Prioritisation: "Prioritisation",
		Deferred: "Deferred",
		Terminated: "Terminated"
	};
